export const ADMIN_BASE_URL = '/admin/api/v1';

export const FREELANCERS_FETCH_PATH = '/freelancers';
export const TIMEZONES_FETCH_PATH = '/timezones';
export const COUNTRIES_FETCH_PATH = '/countries';
export const AUTH_FETCH_PATH = '/auth';
export const LANGUAGE_CODES_FETCH_PATH = '/language-codes';
export const AVATAR_PATH = ADMIN_BASE_URL + FREELANCERS_FETCH_PATH + '/me/avatar';
export const REDIRECT_REBENEFIT_HREF = 'https://app.rebenefit.bg/';
